<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'ADSEnvironmentGroup',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'name',
        placeholder: '分组名称',
        type: 'input',
      }],
      permission: {
        add: 'aDSEnvironmentGroup:add',
        update: 'aDSEnvironmentGroup:update',
        delete: 'aDSEnvironmentGroup:delete',
        deleteBatch: 'aDSEnvironmentGroup:deleteBatch'
      },
      url: {
        get: '/aDSEnvironmentGroup/listByCondition',
        add: '/aDSEnvironmentGroup/add',
        update: '/aDSEnvironmentGroup/update',
        delete: '/aDSEnvironmentGroup/delete',
        delete_batch: '/aDSEnvironmentGroup/deleteBatch',
        status: '/aDSEnvironmentGroup/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },
        {
          field: 'name',  // 字段名
          label: '分组名称',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },{
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'name',  // 字段名
            label: '分组名称',  // 字段显示名称
            type: 'input',
            placeholder: '请输入分组名称',
            rules: [
              {required: true, message: 'name不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
